import { createApi } from "@reduxjs/toolkit/query/react";

import { createCustomFetchBaseQuery } from "../baseQuery";


export const inventoryApi = createApi({
    reducerPath: "inventoryApi",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ["Inventory"],
    endpoints: (builder) => ({
        getAllInventory: builder.query({
            query: ({ pageno, search ,status , sortOrder , sortBy, limit}) => {
                let url = `/contractor/inventory?pageno=${pageno}`;
                if (search) {
                    url += `&search=${search}`;
                }
                if(status){
                    url += `&status=${status}`;
                }
                if(sortOrder){
                    url += `&sortOrder=${sortOrder}`;
                }
                if(sortBy){
                    url += `&sortBy=${sortBy}`;
                }
                if(limit){
                    url += `&limit=${limit}`;
                }
                return {
                    url,
                    method: "GET",
                }
            },  
            providesTags: ["Inventory"],
        }),
        addInventory: builder.mutation({
            query: (data) => ({
                url: `/contractor/inventory`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["Inventory"],
        }),
        updateInventory: builder.mutation({
            query: ({ id, data }) => ({
                url: `/contractor/inventory/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["Inventory"],
        }),
        deleteInventory: builder.mutation({
            query: (id) => ({
                url: `/contractor/inventory/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Inventory"],
        }),
    }),
}); 
export const {
    useGetAllInventoryQuery,
    useAddInventoryMutation,
    useUpdateInventoryMutation,
    useDeleteInventoryMutation,
} = inventoryApi;